export const getRussianPluralVariant = (count) => {
  const lastDigit = count % 10;
  const lastTwoDigits = count % 100;
  
  if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
    return '_5';
  }
  
  if (lastDigit === 1) {
    return '_1';
  } else if (lastDigit >= 2 && lastDigit <= 4) {
    return '_2';
  } else {
    return '_5';
  }
};
